// extracted by mini-css-extract-plugin
module.exports = {"radio":"IconedRadioGroup_radio__nMIVu","indicator":"IconedRadioGroup_indicator__1dZhh"};